import { ls_vars, routes } from "Library/Constants";
import { getLocalStorage } from "Network/ApiService";
import { useNavigate, useParams } from "react-router-dom";

export const useNav = () => {
  const navigate = useNavigate();
  const { project: projectId } = useParams();
  const defaultProjectRef = projectId || getLocalStorage(ls_vars.PROJECT_REF);

  const dashboardNavigate =
    (projectRef = defaultProjectRef) =>
    (route: (pid: any) => string) => {
      if (projectRef) {
        navigate(route(projectRef));
      } else {
        navigate(routes.auth.choseProject);
      }
    };

  return {
    viewLogin: () => navigate(routes.auth.login),
    viewProjectChoose: () => navigate(routes.auth.choseProject),
    viewAccount: () => navigate(routes.profile.account),
    viewOrganization: () => navigate(routes.profile.organization),
    viewNotifications: () => navigate(routes.profile.notification),

    viewHome: (projectRef?: string) =>
      dashboardNavigate(projectRef)(routes.dashboardNav.home),
    viewUserManagement: (projectRef?: string) =>
      dashboardNavigate(projectRef)(routes.dashboardNav.userManagement),
    viewSiteDetails: (projectRef?: string) =>
      dashboardNavigate(projectRef)(routes.dashboardNav.siteDetails),
    viewSettings: (projectRef?: string) =>
      dashboardNavigate(projectRef)(routes.dashboardNav.settings),
    viewSettingsProcore: (projectRef: string, isAuthorize?: boolean) => {
      navigate(
        routes.dashboardNav.settingsProcore(projectRef) +
          (isAuthorize ? "?procore=authorize" : "")
      );
    },
    viewAvailability: (projectRef?: string) =>
      dashboardNavigate(projectRef)(routes.dashboardNav.availability),
    viewBookingForm: (projectRef: string, bookingId?: string) =>
      navigate(routes.dashboardNav.bookingForm(projectRef, bookingId)),
    viewBookingsList: (projectRef?: string) =>
      dashboardNavigate(projectRef)(routes.dashboardNav.bookingsList),
    viewVehicleTracking: (projectRef?: string) =>
      dashboardNavigate(projectRef)(routes.dashboardNav.vehicleTracking),
    viewCalendar: (projectRef?: string) =>
      dashboardNavigate(projectRef)(routes.dashboardNav.calendar),
    viewBookingDetails: (projectRef: string, bookingId: string) =>
      navigate(routes.dashboardNav.bookingDetails(projectRef, bookingId)),
    viewEquipment: (projectRef?: string) =>
      dashboardNavigate(projectRef)(routes.dashboardNav.equipment),
    viewListEquipments: (projectRef?: string) =>
      dashboardNavigate(projectRef)(routes.dashboardNav.listEquipments),
    viewRegisterEquipment: (projectRef?: string) =>
      dashboardNavigate(projectRef)(routes.dashboardNav.registerEquipment),
  };
};
